import React from "react";
import { Alert, AlertTitle, Box, Container, Typography } from "@mui/material";
import { Form, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { apiClientHooks } from "../bootstrapping/InitApiClient";
import GoToDashboardButton from "../components/GoToDashboardButton";

export const Element: React.FC = () => {
  const { application_id } = useParams<{ application_id?: string }>()
  if (!application_id) throw new Error('application_id is required')

  // Get the Stripe Checkout ID in `session_id` from the querystring
  const session_id = new URLSearchParams(window.location.search).get('session_id')
  if (!session_id) throw new Error('session_id is required')

  // Load the Checkout Session Status from the server
  const stripeStatus = apiClientHooks.useStripeStatusForEBulkApplicationByID({
    params: {
      id: application_id,
    },
    queries: {
      session_id,
    },
  })
  const isNotAwaitingPayment = stripeStatus.data?.application === 'application_not_awaiting_payment'
  const isPaid = stripeStatus.data?.payment_status === 'paid'

  return <>
    <Helmet>
      <title>Pay by Stripe</title>
    </Helmet>
    <Container component="main" maxWidth="xs">
      <Form method="post">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h5" marginBottom={3}>
            Pay by Stripe
          </Typography>
          {isNotAwaitingPayment && <>
            <Alert severity="info" sx={{ marginBottom: 3 }}>
              <AlertTitle>No Longer Awaiting Payment</AlertTitle>
              This application is no longer awaiting payment. Please wait for further instruction.
              <GoToDashboardButton variant="contained" sx={{ marginTop: 2 }} />
            </Alert>
          </>}
          {isPaid && <>
            <Alert severity="success" sx={{ marginBottom: 3 }}>
              <AlertTitle>Payment Successful</AlertTitle>
              Your payment has been successfully processed. The application is now ready for countersigning.
              <GoToDashboardButton variant="contained" sx={{ marginTop: 2 }} />
            </Alert>
          </>}
        </Box>
      </Form>
    </Container>
  </>
}

export default Element
